import {
  USER_VERIFICATION_ATTEMPT,
  USER_VERIFICATION_SUCCESS,
  USER_VERIFICATION_FAILED,
  USER_VERIFICATION_SUBMIT_ATTEMPT,
  USER_VERIFICATION_SUBMIT_SUCCESS,
  USER_VERIFICATION_SUBMIT_FAILED,
} from "../types/userVerificationTypes";
import { getDefaultVerificationState } from "../../assets/userVerificationUtils";

const INITIAL_STATE = {
  loading: false,
  submitting: false,
  data: getDefaultVerificationState(),
  error: "",
  submitError: "",
};

function userVerification(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_VERIFICATION_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case USER_VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        error: "",
      };

    case USER_VERIFICATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case USER_VERIFICATION_SUBMIT_ATTEMPT:
      return { ...state, submitting: true, submitError: "" };

    case USER_VERIFICATION_SUBMIT_SUCCESS:
      return {
        ...state,
        submitting: false,
        data: action.data,
        submitError: "",
      };

    case USER_VERIFICATION_SUBMIT_FAILED:
      return {
        ...state,
        submitting: false,
        submitError: action.error,
      };

    default:
      return state;
  }
}

export default userVerification;
